import React, { useEffect } from 'react';
import * as analytics from '../../lib/analytics';
import PromoMessage from '../../redesignComponents/promoMessage/__stories__/promoMessage';

const BrandedCampaign = ({ fptiInfo, i18n, cdnHost, data, isMobile }) => {
  const { authState } = JSON.parse(
    document.getElementById('data-props').innerHTML
  );

  const { country: contentCountry } = JSON.parse(
    document.getElementById('data-locale').innerHTML
  );

  useEffect(() => {
    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_LOADED, {
      e: 'av',
      item_name: 'dw_giving',
      scope: 'module',
      event_source: analytics.getEventSource(isMobile),
      account_type: analytics.getAccountType(authState),
      state: 'populated',
      acct_cntry: contentCountry,
      card_type: 'branded_campaign',
      tile_id: data.id,
      lcid: '-', // TODO Check how to get the lcid
      order: 6,
      module: 'generosity_network',
    });

    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_SHOWN, {
      e: 'im',
      item_name: 'dw_giving',
      scope: 'module',
      event_source: analytics.getEventSource(isMobile),
      account_type: analytics.getAccountType(authState),
      state: 'populated',
      acct_cntry: contentCountry,
      card_type: 'branded_campaign',
      tile_id: data.id,
      lcid: '-', // TODO Check how to get the lcid
      order: 6,
      module: 'generosity network',
    });
  }, []);

  const recordLinkPressedEvent = () => {
    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_PRESSED, {
      e: 'cl',
      item_name: 'dw_giving',
      link_name: 'help now',
      scope: 'module',
      event_source: analytics.getEventSource(isMobile),
      account_type: analytics.getAccountType(authState),
      state: 'populated',
      acct_cntry: contentCountry,
      card_type: 'branded_campaign',
      tile_id: data.id,
      lcid: '-', // TODO Check how to get the lcid
      order: 6,
      module: 'generosity_network',
    });
  };

  return (
    <PromoMessage
      header={data.campaignTitle}
      headerSize='lg'
      subHeader={data.campaignDescription}
      CTAText={data.ctaText}
      CTAUrl={data.ctaUrl}
      backgroundColor={data.backgroundColor}
      imageUrl={data.campaignImage}
      imagePosition='right'
      hasImageOffset={false}
      promoContainerOffset={true}
      isDarkBackground={data.isDarkBackground}
      isTertiaryButton={true}
      onClick={recordLinkPressedEvent}
    />
  );
};

export default BrandedCampaign;
